import styles from './CurrentEventTask.module.css';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { 
    selectCurrentEventTaskAmountAsText, 
    setAmount,
} from './currentEventTaskSlice'
import { Fragment } from 'react';
import CurrencyInput from '../../app/controls/CurrencyInput';

export function AdditionalSendMoneyTaskInfo() {
    const amount = useAppSelector(selectCurrentEventTaskAmountAsText)
    const dispatch = useAppDispatch()
    return (
        <Fragment>
            <label className={styles.label} htmlFor='txtAmount'>Amount:</label>
            <CurrencyInput
                id='txtItemName'
                className={styles.textbox}
                aria-label='Set Amount'
                value={amount}
                onChange={(e: { target: { value: string; }; }) => dispatch(setAmount(e.target.value))}
            />
        </Fragment>
    )
}